import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "religion",
  legacy: {
    data: "religion",
    count: "count",
    fetch: "fetchReligions",
    create: "createOneReligion",
    update: "updateReligion",
    remove: "deleteReligion",
    updateState: "updateReligionState",
  },
});

export const ReligionProvider = Provider;
export const useReligionContext = useValue;
